export default {
  SET_PAYMENT_METHODS (state, payment_methods) {
    state.payment_methods = payment_methods
  },
  REMOVE_RECORD (state, itemId) {
    const paymentMethodIndex = state.payment_methods.findIndex((u) => u.id === itemId)
    state.payment_methods.splice(paymentMethodIndex, 1)
  }
}
